import { render } from "./FluidsDataStudioTwo.vue?vue&type=template&id=e50bd9f2"
import script from "./FluidsDataStudioTwo.vue?vue&type=script&lang=js"
export * from "./FluidsDataStudioTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__